module.exports = __webpack_public_path__ + "img/automatic-round.f23e41fb.svg";